/** @griffel:css-start [d] null **/
.f1ewtqcl{box-sizing:border-box;}
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
.fuzgk9b{min-inline-size:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fop8ug2{padding:20px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1o0qvyv{border-radius:var(--borderRadiusLarge);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fwyddsq{border-inline-start-style:solid;}
.f1ftuoky{border-inline-start-color:var(--colorNeutralStroke2);}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.fwl1lcr{border-inline-end-style:solid;}
.f1crbv9w{border-inline-end-color:var(--colorNeutralStroke2);}
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.foi3q75{border-block-start-color:var(--colorNeutralStroke2);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f1p2dij1{border-block-end-style:solid;}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.f1whvlc6{box-shadow:var(--shadow4);}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f4ybsrx{font-size:16px;}
.f8xlz6g{line-height:24px;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f19n0e5{color:var(--colorNeutralForeground1);}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.fi64zpg{flex-shrink:0;}
/** @griffel:css-end **/